import React from 'react'
import { Col, Row } from 'antd'
import { BBDTag, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { getSupplyTotal } from './util'

type SupplyDifferencesProps = {
  newSupply: Gravitate.SupplyOption
  oldSupply: Gravitate.SupplyOption
}

export function SupplyDifferences({ newSupply, oldSupply }: SupplyDifferencesProps) {
  return (
    <>
      <Row justify='space-between'>
        <Col>
          <Texto weight='bold' className='mt-3 mb-3'>
            Before:
          </Texto>
        </Col>
        <Col>
          <Texto className='mt-3 mb-3' weight='bold'>
            $ {getSupplyTotal(oldSupply.product_total, oldSupply.total_freight)}
          </Texto>
        </Col>
      </Row>
      <PriceBreakdown priceList={oldSupply} />
      <Row justify='space-between'>
        <Col>
          <Texto weight='bold' appearance='secondary' className='mt-3 mb-3'>
            After:
          </Texto>
        </Col>
        <Col>
          <Texto className='mt-3 mb-3' weight='bold'>
            $ {getSupplyTotal(newSupply.product_total, newSupply.total_freight)}
          </Texto>
        </Col>
      </Row>
      <PriceBreakdown priceList={newSupply} />
    </>
  )
}

type PriceBreakdownProps = {
  priceList: Gravitate.SupplyOption
}

function PriceBreakdown({ priceList }: PriceBreakdownProps) {
  return (
    <>
      {priceList.prices.map((product, index) => (
        <Vertical flex={'none'} style={{ display: 'inherit' }} key={index} className='mb-5'>
          <BBDTag>
            <b>{product.product_name}</b>
          </BBDTag>

          {product.components.map((details, index) => (
            <Vertical key={index} height={'auto'} className='product-divider pl-3 mt-3'>
              <Horizontal>
                <Texto weight='bold' className='flex-1' appearance='primary'>
                  {details.terminal}
                </Texto>
                <Texto weight='bold' appearance='primary'>
                  {details.product}
                </Texto>
              </Horizontal>
              <Horizontal>
                <Texto className='flex-1'>{details.supplier} -</Texto>
                <Texto textTransform='capitalize'>{details.price_type}</Texto>
              </Horizontal>
              <Horizontal>
                <Texto className='flex-1'>
                  {formatters.DATE_TIME(new Date(details.effective_from), details.effective_from_local)} - <br />
                  {formatters.DATE_TIME(new Date(details.effective_to), details.effective_to_local)}
                </Texto>
                <Texto>$ {details.price}</Texto>
              </Horizontal>
            </Vertical>
          ))}
        </Vertical>
      ))}
    </>
  )
}
